import _ from "lodash";
import ko from "knockout";
import evaluationFormService from "services/composer/evaluationFormService";
import ViewModel from "viewModels/ViewModel";
import featureToggleService, {
    FeatureToggle,
} from "services/featureToggleService";

/**
 * The EvaluationFormSelectorView class.
 * @class
 */
const EvaluationFormSelectorView = ViewModel.extend(function (
    evaluationFormObservable,
    isCalibration
) {
    const self = this;
    const isSparkFlareFTEnabled = featureToggleService.isEnabled(
        FeatureToggle.WEM_1418_IDUI_SPARK_V4_FLARE
    );

    self.loading = ko.observable(false);
    self.isEvaluationFormDropdownLoading = ko.observable(false);
    self.isCalibration = ko.isObservable(isCalibration)
        ? isCalibration
        : ko.observable(isCalibration || false);

    self.evaluationForm = evaluationFormObservable;

    self.placeholderText = ko.i18n.renderString(
        "evaluationFormSelector.placeholderText"
    );
    self.filteredEvaluationForms = ko.observableArray([]);

    self.getPublishedEvaluationForms = function (searchTerm) {
        const pageParams = {
            name: searchTerm,
            onlyLatestPerContext: true,
        };

        // Only add evaluationFormType for calibration mode
        if (self.isCalibration()) {
            pageParams.evaluationFormType = "Traditional";
        }

        return evaluationFormService.get.published
            .page(pageParams)
            .then(function (evaluationFormsPage) {
                // Make sure evaluation forms from evalFormService get unwrapped.
                // They are initialized with utility functions for editing and validating
                // (that we don't care about) which cause the model to be rejected
                // by the service otherwise.
                const evalForms = _.invokeMap(
                    evaluationFormsPage.asList(),
                    "unwrap"
                );
                if (isSparkFlareFTEnabled) {
                    self.filteredEvaluationForms(evalForms);
                    self.isEvaluationFormDropdownLoading(false);
                }

                return evalForms;
            });
    };

    // Cannot apply debounce to the getPublishedEvaluationForms function directly because it is used for select2 dropdown
    const debouncedGetPublishedEvaluationForms = _.debounce(
        self.getPublishedEvaluationForms,
        500
    );

    self.handleEvaluationFormFilter = function (_data, event) {
        if (isSparkFlareFTEnabled) {
            const searchTerm = event?.detail || "";
            self.isEvaluationFormDropdownLoading(true);
            debouncedGetPublishedEvaluationForms(searchTerm);
        }
    };

    self.onEvaluationFormChange = function (_data, event) {
        const evaluationFormId = event?.target?.value;
        if (!evaluationFormId) {
            return;
        }
        const evaluationForm = self
            .filteredEvaluationForms()
            .find((form) => form.id === evaluationFormId);
        self.evaluationForm(evaluationForm);
    };

    if (_.isArray(self.evaluationForm())) {
        self.evaluationForm.extend({
            deepComparer: true,
            minLength: {
                params: 1,
                message: "evaluationFormSelector.noFormSelected",
            },
        });
    } else {
        self.evaluationForm.extend({ required: true });
    }

    self.onDispose = function () {
        if (debouncedGetPublishedEvaluationForms?.cancel) {
            debouncedGetPublishedEvaluationForms.cancel();
        }
    };
},
true /* pass args to extended class */);

export default EvaluationFormSelectorView;
